"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const isFunction = (v) => {
    return 'function' === typeof v;
};
const stripWhitespace = (input) => {
    return input ? input.replace(/^[\s\xa0]+|[\s\xa0]+$/g, '') : '';
};
const startsWith = (input, searchString) => {
    return 0 === input.indexOf(searchString);
};
const stripLeadingDot = (input) => {
    return 0 === input.indexOf('.') ? input.substr(1) : input;
};
const generateRandomNumber = () => {
    return Math.round(2147483647 * Math.random());
};
const trace = (...args) => {
    // console.log(args);
};
exports.default = {
    generateRandomNumber,
    isFunction,
    startsWith,
    stripLeadingDot,
    stripWhitespace,
    trace,
};
